import React from 'react';
import { AnimatedFooter } from './ui/AnimatedFooter';
export function Footer() {
  return <AnimatedFooter leftLinks={[{
    href: '/terminos',
    label: 'Términos y condiciones'
  }, {
    href: '/privacidad',
    label: 'Política de privacidad'
  }]} rightLinks={[{
    href: '/',
    label: 'Inicio'
  }, {
    href: '/servicios',
    label: 'Servicios'
  }, {
    href: '/proceso',
    label: 'Proceso'
  }, {
    href: '/resultados',
    label: 'Resultados'
  }, {
    href: '/faq',
    label: 'FAQ'
  }, {
    href: '/contacto',
    label: 'Contacto'
  }]} copyrightText={`Growthly ${new Date().getFullYear()}. Todos los derechos reservados.`} barCount={23} data-id="element-24" data-mp="3gfsmebmgesmg" />;
}